import { render, staticRenderFns } from "./NaviGuide.vue?vue&type=template&id=aed9be52&scoped=true&"
import script from "./NaviGuide.vue?vue&type=script&lang=js&"
export * from "./NaviGuide.vue?vue&type=script&lang=js&"
import style0 from "./NaviGuide.vue?vue&type=style&index=0&id=aed9be52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed9be52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
